import { Button, DefineTermDescription, LinkText } from '@/components';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { PublishedProjectMutableGuard } from '@/features/authentication/_components/PublishedProjectMutableGuard';
import { useProject } from '@/features/project/_hooks/project';
import { AddGroupTargetFormModal } from '@/features/project/groups/_components/AddGroupTargetFormModal';
import { useGroupTargets } from '@/features/project/groups/_hooks/group';
import { useId } from '@/hooks';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const GroupTag = () => {
  const { t } = useTranslation();
  const { id } = useId();
  const groupTargets = useGroupTargets({ objectId: id });
  const project = useProject(id);
  const fiscalYear = project.data?.fiscalYear;

  const [openModal, setOpenModal] = useState(false);

  return (
    <>
      <DefineTermDescription
        size="medium"
        term={t('project-group')}
        items={
          groupTargets.data?.groupWiseDetails.map((group) => (
            <LinkText
              size="md"
              key={group.groupId}
              text={group.group.name}
              href={`/rs/project/group/${group.groupId}`}
            />
          )) ?? []
        }
        thresholdToViewMore={2}
        extra={
          <ProjectResourceGuard onlyEdit>
            <PublishedProjectMutableGuard>
              <Button
                size="small"
                type="link"
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                {t('add')}
              </Button>
            </PublishedProjectMutableGuard>
          </ProjectResourceGuard>
        }
      />
      <AddGroupTargetFormModal
        open={openModal}
        targetType="project"
        objectId={id}
        fiscalYear={fiscalYear}
        onClose={() => {
          setOpenModal(false);
        }}
      />
    </>
  );
};
